import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { createBanca, getBanca } from '../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';

const NuovoBanca = () => {
  const initialFormData = {
    denominazione: '',
    telefono: '',
    cellulare: '',
    email: '',
    iban: '',
    bic: '',
    costo_transazione_percentuale: '',
    referente: '',
    firefly_asset_account_name: '',
    use_for_ecommerce_bonifico: false // Nuovo campo
  };

  const [formData, setFormData] = useState(initialFormData);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const duplicateId = queryParams.get('duplicateId');

    if (duplicateId) {
      const fetchBancaToDuplicate = async () => {
        try {
          const response = await getBanca(parseInt(duplicateId));
          const duplicatedBanca = response.data;

          // Clear unique fields and ID for duplication
          setFormData({
            ...duplicatedBanca,
            id: undefined, // Ensure ID is not sent for new creation
            denominazione: duplicatedBanca.denominazione ? `${duplicatedBanca.denominazione} (Copia)` : null,
            email: null,
            iban: null,
            use_for_ecommerce_bonifico: !!duplicatedBanca.use_for_ecommerce_bonifico // Duplica anche questo campo
            // Other fields that should be unique or reset for a new record
          });
          // Optionally remove duplicateId from URL after processing
          navigate(location.pathname, { replace: true });
        } catch (error) {
          console.error("Errore durante il recupero della banca per la duplicazione:", error);
          alert("Errore durante il recupero dei dati per la duplicazione.");
        }
      };
      fetchBancaToDuplicate();
    }
  }, [location.search, navigate, location.pathname]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ 
        ...formData, 
        [name]: type === 'checkbox' ? checked : (type === 'number' ? parseFloat(value) : value) 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createBanca(formData);
      alert('Banca creata con successo!');
      navigate('/banche');
    } catch (error) {
      console.error('Errore nella creazione della banca:', error.response || error);
      alert('Errore nella creazione della banca.');
    }
  };

  return (
    <Container>
        <Row className="align-items-center mb-3">
            <Col>
                <h2>Nuova Banca</h2>
            </Col>
            <Col xs="auto" className="ms-auto">
                <Button variant="secondary" onClick={() => navigate('/banche')} className="me-2">
                    Torna alla Lista
                </Button>
                <Button variant="primary" type="submit" form="banca-form">
                    Salva Banca
                </Button>
            </Col>
        </Row>
      <Form id="banca-form" onSubmit={handleSubmit}>
        <Card className="mb-4">
          <Card.Header>ANAGRAFICA BANCA</Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="formDenominazione">
              <Form.Label>Denominazione</Form.Label>
              <Form.Control type="text" name="denominazione" value={formData.denominazione} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formReferente">
              <Form.Label>Referente</Form.Label>
              <Form.Control type="text" name="referente" value={formData.referente} onChange={handleChange} />
            </Form.Group>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Header>CONTATTI</Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}><Form.Group className="mb-3" controlId="formTelefono"><Form.Label>Telefono</Form.Label><Form.Control type="tel" name="telefono" value={formData.telefono} onChange={handleChange} placeholder="es. 06 / 1234567" /></Form.Group></Col>
              <Col md={6}><Form.Group className="mb-3" controlId="formCellulare"><Form.Label>Cellulare</Form.Label><Form.Control type="tel" name="cellulare" value={formData.cellulare} onChange={handleChange} placeholder="es. 333 / 1234567" /></Form.Group></Col>
            </Row>
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="Usa per bonifici e-commerce"
                name="use_for_ecommerce_bonifico"
                checked={formData.use_for_ecommerce_bonifico || false}
                onChange={handleChange}
              />
              <Form.Text className="text-muted">
                Spuntare se questa banca deve essere usata per mostrare le coordinate in caso di pagamento con bonifico per ordini e-commerce.
              </Form.Text>
            </Form.Group>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Header>COORDINATE E CONDIZIONI</Card.Header>
          <Card.Body>
            <Row>
                <Col md={8}><Form.Group className="mb-3" controlId="formIban"><Form.Label>IBAN</Form.Label><Form.Control type="text" name="iban" value={formData.iban} onChange={handleChange} minLength="27" maxLength="27" /></Form.Group></Col>
                <Col md={4}><Form.Group className="mb-3" controlId="formBic"><Form.Label>BIC/Swift</Form.Label><Form.Control type="text" name="bic" value={formData.bic} onChange={handleChange} /></Form.Group></Col>
            </Row>
            <Form.Group className="mb-3" controlId="formCostoTransazione">
                <Form.Label>Costo Transazione (%)</Form.Label>
                <Form.Control type="number" step="0.01" name="costo_transazione_percentuale" value={formData.costo_transazione_percentuale} onChange={handleChange} />
            </Form.Group>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Header>Integrazione Firefly III</Card.Header>
          <Card.Body>
            <Form.Group className="mb-3">
              <Form.Label>Nome Conto Patrimoniale Firefly III</Form.Label>
              <Form.Control 
                type="text" 
                name="firefly_asset_account_name" 
                value={formData.firefly_asset_account_name || ''} 
                onChange={handleChange} 
                placeholder="Es: Conto Corrente Principale"
              />
              <Form.Text className="text-muted">
                Inserire il nome esatto del conto patrimoniale (asset account) su Firefly III.
              </Form.Text>
            </Form.Group>
          </Card.Body>
        </Card>


      </Form>
    </Container>
  );
};

export default NuovoBanca;

